import { TYPE, PAGE_TYPE } from './consts';
import { gunzipFromBase64 } from '@/utils/gzip';
import { cloneDeep, set } from 'lodash';
/**
 * Checks if a given page is a content page.
 * @param page - The page object to check.
 * @returns True if the page is a content page, false otherwise.
 */
export const isContentPage = (page) => {
    if (!page)
        return false;
    const content = !page.pageType || page.pageType === PAGE_TYPE.CONTENT; // 内容类型页面
    const dataTable = isDataTablePage(page); // 数据表页面
    return content || dataTable;
};
/**
 * Checks if a given page is a data table page.
 * @param page - The page object to check.
 * @returns True if the page is a data table page, false otherwise.
 */
export const isDataTablePage = (page) => {
    if (!page)
        return false;
    return page.pageType === PAGE_TYPE.DATA_TABLE;
};
export const isCodePage = (page) => {
    if (!page)
        return false;
    return page.type === TYPE.Code;
};
export const isAIPage = (page) => {
    if (!page)
        return false;
    return page.type === TYPE.AI;
};
export const unzipPage = async (page) => {
    if (!isAIPage(page))
        return page;
    if (!page.pageConfig)
        return page;
    if (!page.pageConfig.gzip)
        return page;
    try {
        const pageConfig = await gunzipFromBase64(page.pageConfig.content);
        const clonePage = cloneDeep(page);
        set(clonePage, 'pageConfig', pageConfig);
        return clonePage;
    }
    catch (error) {
        console.error(error);
        return page;
    }
};
